import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseApiService } from '@core/api/base-api.service';
import { InvitationDto, InvitationStatus, SendInvitationPayload } from '../models/rbac.model';

@Injectable({ providedIn: 'root' })
export class InvitationService {
  private readonly api = inject(BaseApiService);
  private readonly base = 'v1/admin/rbac/tenants';

  private mapInvitation(raw: any): InvitationDto {
    return {
      invitationId: Number(raw?.invitationId ?? raw?.id ?? 0),
      tenantUuid: raw?.tenantUuid ?? '',
      email: raw?.email ?? '',
      code: raw?.code ?? '',
      status: (raw?.status as InvitationStatus) ?? 'active',
      expiredAt: String(raw?.expiredAt ?? ''),
      createdBy: raw?.createdBy ?? '',
      createdAt: String(raw?.createdAt ?? ''),
    };
  }

  getInvitations(tenantUuid: string): Observable<readonly InvitationDto[]> {
    return this.api
      .get<readonly any[]>(`${this.base}/${tenantUuid}/invitations`)
      .pipe(map((arr) => (Array.isArray(arr) ? arr : []).map((i) => this.mapInvitation(i))));
  }

  sendInvitation(tenantUuid: string, payload: SendInvitationPayload): Observable<InvitationDto> {
    return this.api
      .post<any>(`${this.base}/${tenantUuid}/invitations`, payload)
      .pipe(map((i) => this.mapInvitation(i)));
  }

  revokeInvitation(tenantUuid: string, invitationId: number): Observable<void> {
    return this.api
      .delete(`${this.base}/${tenantUuid}/invitations/${invitationId}`)
      .pipe(map(() => void 0));
  }
}
